// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Aliases for some common ISO8601 durations.
 */
export const Durations = {
  /** Alias for ISO8601 value 'P7D' */
  sevenDays: "P7D",
  /** Alias for ISO8601 value 'P3D' */
  threeDays: "P3D",
  /** Alias for ISO8601 value 'P2D' */
  twoDays: "P2D",
  /** Alias for ISO8601 value 'P1D' */
  oneDay: "P1D",
  /** Alias for ISO8601 value 'PT1H' */
  oneHour: "PT1H",
  /** Alias for ISO8601 value 'PT4H' */
  fourHours: "PT4H",
  /** Alias for ISO8601 value 'PT24H' */
  twentyFourHours: "PT24H",
  /** Alias for ISO8601 value 'PT48H' */
  fortyEightHours: "PT48H",
  /**
   * @deprecated Alias name `fourtyEightHours` for ISO8601 value 'PT48H' is deprecated
   */
  fourtyEightHours: "PT48H",
  /** Alias for ISO8601 value 'PT30M' */
  thirtyMinutes: "PT30M",
  /** Alias for ISO8601 value 'PT5M' */
  fiveMinutes: "PT5M",
} as const;
